module.exports = __webpack_public_path__ + "img/register_head.868d6ba6.png";